import { usePostHog } from "posthog-js/react";
import type { QuickReplyKey } from "./quick-replies";

const BASE = {
    entry_variant: "assist",
    surface: "first_run_assist",
} as const;

export type AssistAsk = QuickReplyKey;

export function useFirstRunAssistAnalytics() {
    const posthog = usePostHog();

    return {
        conciergeShown: () => posthog.capture("assist_concierge_shown", BASE),

        askShown: (ask: AssistAsk) =>
            posthog.capture("assist_ask_shown", { ...BASE, ask }),

        askAnswered: (ask: AssistAsk, value: string) =>
            posthog.capture("assist_ask_answered", {
                ...BASE,
                ask,
                value,
            }),

        askDismissed: (ask: AssistAsk) =>
            posthog.capture("assist_ask_dismissed", { ...BASE, ask }),

        spotlightShown: (dogId: string, fitState: "locked" | "revealed") =>
            posthog.capture("assist_spotlight_shown", {
                ...BASE,
                dog_id: dogId,
                fit_state: fitState,
            }),

        spotlightCta: (choice: "see_dog" | "keep_browsing" | "sign_in") =>
            posthog.capture("assist_spotlight_cta", { ...BASE, choice }),

        save: () => posthog.capture("assist_save", BASE),

        dogOpened: () => posthog.capture("assist_dog_opened", BASE),

        signinPromptShown: () =>
            posthog.capture("assist_signin_prompt_shown", BASE),

        signinClicked: () => posthog.capture("assist_signin_clicked", BASE),
    };
}
